import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const notificationsRoutes = [
  {
    path: 'notifications',
    name: 'Notifications',
    component: () => import('@/features/notifications/views/Notifications.vue'),
    meta: {
      title: `${t('notifications')} | Pour Now`,
      mainRouteName: 'Notifications',
    },
  },
]
